import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import AuthStore from "../../stores/AuthStore";
import styles from "./index.module.scss";
import MenuSide from "./MenuSide";
import PageHeader from "./PageHeader";
import { observer } from "mobx-react";

const AdminPage: React.FC = (props) => {
  const { ssoIsLogin, orAdmin } = AuthStore;

  const navigate = useNavigate();

  useEffect(() => {
    if (!ssoIsLogin) {
      navigate("/sso/login");
      return;
    }
    if (!Boolean(parseInt(orAdmin as string))) {
      navigate("/403/1");
    }
  }, []);

  return (
    <div className={styles.admin_page}>
      <PageHeader />

      <main>
        <MenuSide />
        <aside className={styles.page_content_wrapper}>
          <div className={styles.page_content}>
            <Outlet />
          </div>
        </aside>
      </main>
    </div>
  );
};

export default observer(AdminPage);
